<!-- <app-header [showBackButtonBlack]="showBackButtonBlack" [showPageRoute]="showPageRoute"
[headerTitle]="headerTitle"></app-header> -->
<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

<div class="analytics_page">
    <div class="breadCrumb">
        <div>
            <img [routerLink]="'/my-dashboard'" src="../../assets/images/backarrlibrary.svg" alt="">
            <span class="learning">Team Analytics</span>
            <!-- <span class="library">Library</span> -->
        </div>
        <div [routerLink]="'/profile-page'" class="profile">
            <img [src]="userPic ? userPic : '../../../../../assets/images/user (1).png'" id="header_img">
			<!-- <span *ngIf="firstName" class="firstName">{{ firstName }}</span> -->
            <span *ngIf="userName" class="fullName">{{ userName }}</span>
        </div>
    </div>

	<div id="header_analytics">
		<!-- 5 -->
		<p id="updated-at">
			<!-- <button class="generate_btn" (click)="generateFilteredResults()">Update Analytics</button> -->
			<span *ngIf="lastUpdatedAt">Team Analytics: Last Updated: {{ lastUpdatedAt | date: "medium" }}</span>
			<img *ngIf="!gotUpdatedData" src="../../../../../assets/gifs/Eclipse-Spinner.gif" alt="Spinner gif" id="spinner_gif">
			<!-- <span *ngIf="!gotUpdatedData"> Updating Data...</span> -->
		</p>

		<!-- 4 -->
		<div class="exportCsv">
            <button [disabled]="!gotUpdatedData || isRebuildingAnalytics" class="generate_btn" (click)="generateFilteredResults()">Apply Filters</button>
            <button [disabled]="!gotUpdatedData || isRebuildingAnalytics" class="generate_btn" style="margin-left:8px;" (click)="rebuildAnalytics()">
                {{ isRebuildingAnalytics ? 'Refreshing...' : 'Refresh Now' }}
            </button>
		</div>

		<div [routerLink]="'/profile-page'" class="user-dp-name">
            <img [src]="userPic ? userPic : '../../../../../assets/images/user (1).png'" id="header_img">
            <span>{{ userName }}</span>
        </div>
	</div>

	<!-- carousel for desktop  -->
    <div class="main-carousel-box">
        <!-- <ngb-carousel class="carousel_ngb" [showNavigationArrows]="true" [showNavigationIndicators]="true" [interval]="0" [wrap]="false"> -->
            <!-- <ng-template ngbSlide> -->
                <div class="swiper_container top-tabs-box">
                    <div class="tab-box" *ngFor="let orgLevel of orgLevels; let i = index">
                        <div class="cards swiper-slide-container" *ngIf="i >= managerAtLevelNumber">
                            <mat-form-field class="mat_form_field" appearance="fill">
                                <mat-label>{{ capitalizeFirstWord(orgLevel) }}</mat-label>
                                <mat-select [value]="getDropdownValue(i)" (selectionChange)="changeCurrLevels(i, $event.value)">
                                    <mat-option *ngIf="dropdownOptions.length >= 1" value="all">All</mat-option>
                                    <mat-option *ngFor="let val of dropdownOptions[i]" [value]="val.value">
                                        {{ val.displayValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <!-- <div style="flex-basis: 10%;">
                        <div class="cards swiper-slide-container" *ngIf="orgId && allSystemPrograms.length >= 1">
                            <mat-form-field class="mat_form_field" appearance="fill">
                                <mat-label>Program</mat-label>
                                <mat-select [value]="selectedProgramId">
                                    <mat-option *ngIf="allSystemPrograms.length >= 1" value="all" (click)="filterByProgram('all')">All</mat-option>
                                    <mat-option *ngFor="let program of allSystemPrograms" [value]="program.id" (click)="filterByProgram(program.id)">
                                        {{ program.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div> -->

                </div>
            <!-- </ng-template> -->

            <!-- <ng-template ngbSlide>
                <div style="    width: 10%;
                " class="cards swiper-slide-container" *ngIf="orgId && allSystemPrograms.length >= 1">
                    <mat-form-field class="mat_form_field" appearance="fill">
                        <mat-label>Program</mat-label>
                        <mat-select [value]="selectedProgramId">
                            <mat-option *ngIf="allSystemPrograms.length >= 1" value="all" (click)="filterByProgram('all')">All</mat-option>
                            <mat-option *ngFor="let program of allSystemPrograms" [value]="program.id" (click)="filterByProgram(program.id)">
                                {{ program.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </ng-template> -->

        <!-- </ngb-carousel> -->

        <div class="program-box role-box" *ngIf="orgId && allSystemPrograms.length >= 1">
            <mat-form-field class="mat_form_field" appearance="fill">
                <mat-label>Roles</mat-label>
                <mat-select multiple [(ngModel)]="selectedRoles">
                    <mat-option [value]="'all'" (click)="toggleSelectAllRoles()">All</mat-option>

                    <!-- <mat-option [ngStyle]="{'pointer-events': isAllRolesSelected ? 'none' : 'auto'}" [disabled]="isAllRolesSelected" *ngFor="let roleKey of rolesKeys" [value]="roleKey" (click)="roleOptionClick()"> -->
                    <mat-option *ngFor="let roleKey of rolesKeys" [value]="roleKey" (click)="roleOptionClick()">
                        {{ rolesData[roleKey] }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="program-box">
            <div class="cards swiper-slide-container" *ngIf="orgId && allSystemPrograms.length >= 1">
                <!-- <mat-form-field class="mat_form_field" appearance="fill">
                    <mat-label>Program</mat-label>
                    <mat-select [value]="selectedProgramId">
                        <mat-option *ngIf="allSystemPrograms.length >= 1" value="all" (click)="filterByProgram('all')">All</mat-option>
                        <mat-option *ngFor="let program of allSystemPrograms" [value]="program.id" (click)="filterByProgram(program.id)">
                            {{ program.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->

                <mat-form-field class="mat_form_field" appearance="fill">
                    <mat-label>Program</mat-label>
                    <mat-select multiple [(ngModel)]="selectedProgramIds">
                        <!-- Select All Option (Added to selected values) -->
                        <mat-option [value]="'all'" (click)="toggleAllSelection()">
                           All
                        </mat-option>

                        <!-- Individual Program Options -->
                        <mat-option [ngStyle]="{'pointer-events': allSelected ? 'none' : 'auto'}" [disabled]="allSelected" *ngFor="let program of allSystemPrograms" [value]="program.id" (click)="optionClick()">
                            {{ program.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <!-- mobile dropdowns  -->

    <!-- <div class="swiper_container mob">
		<div *ngFor="let orgLevel of orgLevels; let i = index">
			<div class="cards swiper-slide-container" *ngIf="i >= managerAtLevelNumber">
				<mat-form-field appearance="fill">
					<mat-label>{{ capitalizeFirstWord(orgLevel) }}</mat-label>
					<mat-select [value]="currLevels[i]">
						<mat-option *ngIf="dropdownOptions.length >= 1" value="all" (click)="changeCurrLevels(i, 'all')">All</mat-option>
						<mat-option *ngFor="let val of dropdownOptions[i]" [value]="val" (click)="changeCurrLevels(i, val)">
							{{ capitalizeFirstWord(val) }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div class="cards swiper-slide-container" *ngIf="orgId && allSystemPrograms.length >= 1">
			<mat-form-field appearance="fill">
				<mat-label>Program</mat-label>
				<mat-select [value]="selectedProgramId">
					<mat-option *ngIf="allSystemPrograms.length >= 1" value="all" (click)="filterByProgram('all')">All</mat-option>
					<mat-option *ngFor="let program of allSystemPrograms" [value]="program.id" (click)="filterByProgram(program.id)">
						{{ program.name }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
    </div> -->

    <!-- mobile dropdown end  -->

    <div class="first-row-cards">
        <!-- <div class="left-box">
            <div class="second_container"> -->
        <div class="left-box" [ngStyle]="{'max-height': isExpand ? 100 + '%' : dyanamicHeight + 'px' }">
            <div class="second_container" style="display: flex;flex-direction: column;height: 100%;">

                <!-- <img src="assets/gifs/flip-analytics-pointer.gif"> -->
                <!-- <img style="height: 220px" src="../../../../../assets/images/smiley-gif.gif" /> -->

                <!-- <div class="container" style="   padding-bottom: 10px !important; flex-basis: 40% !important"> -->
                <div class="container_head">
                    <div class="card-top-title">
                        Overall Program Completion Rates
                    </div>
                    <div class="badges">
                        <button>Completed</button>
                        <button>In&nbsp;Progress</button>
                        <button>Not&nbsp;Started</button>
                    </div>
                </div>
                <div class="card-top-sub-title" style="margin-bottom: 0px !important;">
                    <span>Program Name</span>
                    <span>Eligible</span>
                </div>
                <!-- <div [ngStyle]="{'max-height': isExpand ? 100 + '%' : (dyanamicHeight - 125) + 'px' }" class="marks program_completion" *ngIf="programCompletion && programCompletion.length >= 1"> -->
                <div [ngStyle]="{'max-height': 100 + '%'}" class="marks program_completion" *ngIf="programCompletion && programCompletion.length >= 1">

                    <div class="program_row" *ngFor="let complete of programCompletion; let i = index">
                        <div class="prog_nme">{{complete.name}}</div>

                        <div class="w3-border" style="display: flex;align-items: center;font-size: 10px;">
                            <!-- <div [ngStyle]="{'display': 'flex', 'width': 'calc(100% - ' + complete.notStartedPercentage + '%)'}"> -->
							<div *ngIf="complete.completedPercentage" class="w3-grey" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': complete.completedPercentage +'%'}" [id]="'item-completed' + i">
								<span *ngIf="complete.completedPercentage >= 11">
									{{complete.userCompleted}}
								</span>
								<div class="complete-tooltip tooltip-box">{{complete.completedPercentage +'%'}} ({{complete.userCompleted}})</div>
							</div>

							<div *ngIf="complete.progressPercentage" class="w3-inprogress" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': complete.progressPercentage +'%'}" [id]="'item-progress' + i">
								<span *ngIf="complete.progressPercentage >= 11">
									{{complete.inProgress}}
								</span>
								<div class="progress-tooltip tooltip-box">{{complete.progressPercentage}}% ({{complete.inProgress}})</div>
							</div>
                            <!-- </div> -->

                            <div *ngIf="complete.notStartedPercentage" class="w3-notstarted" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': complete.notStartedPercentage +'%'}">
                                <span *ngIf="complete.notStartedPercentage >= 11">
									{{complete.notStarted}}
								</span>
                                <div class="notStarted-tooltip tooltip-box">{{complete.notStartedPercentage}}% ({{complete.notStarted}})</div>
                            </div>
                        </div>

                        <span>{{complete.totalUser}}</span>
                    </div>
                </div>

                <div class="expand-button">
                    <mat-icon *ngIf="!isExpand" (click)="expandProgramContainer()">arrow_drop_down</mat-icon>
                    <mat-icon *ngIf="isExpand" (click)="expandProgramContainer()">arrow_drop_up</mat-icon>
                </div>

                <!-- </div> -->
            </div>
        </div>
        <div class="right-box" #cardElement>
            <div class="top-boxes">
                <div class="top-left">
                    <h4 class="card-top-title"><span>Avg Monthly D.O.S.E's</span> <span>Goal 20</span></h4>
                    <div class="progress-percent">
                        <div class="nme">My Team</div>
                        <div class="prg-border">
							<!-- <span class="percent">Coming Soon </span> -->
                            <!-- <div class="prg-grey" [ngStyle]="{'height':'12px', 'width': 0 +'%'}"></div> -->
                            <span class="percent">{{ teamAverage === -1 ? "Loading": teamAverage }}</span>
                            <div class="prg-grey" [ngStyle]="{'height':'12px', 'width': teamAveragePercentage +'%'}"></div>
                        </div>
                    </div>
                    <div class="progress-percent">
                        <div class="nme">My Company</div>
                        <div class="prg-border">
                            <span class="percent">{{ companyAverage === -1 ? "Loading" : companyAverage }}</span>
                            <div class="prg-grey" [ngStyle]="{'height':'12px', 'width': companyAveragePercentage +'%'}"></div>
                        </div>
                    </div>
                    <div class="progress-percent">
                        <div class="nme">Ignite Community</div>
                        <div class="prg-border">
                            <span class="percent">{{ industryAverage === -1 ? "Loading" : industryAverage }}</span>
                            <div class="prg-grey" [ngStyle]="{'height':'12px', 'width': industryAveragePercentage +'%'}"></div>
                        </div>
                    </div>
                </div>
                <div class="top-right">
                    <div>
                        <h4 class="card-top-title">Total Learners</h4>
                        <p>{{ numberOfUsers }}</p>
                    </div>
                    <div>
                        <h4 class="card-top-title">Total Locations</h4>
                        <p>{{ numberOfLocations }}</p>
                    </div>
                </div>
            </div>
            <div class="right-bottom">
                <img src="../../../../../assets/images/team-analytics/first-row-img.png" alt="">
                <!-- <h4 class="card-top-title">Total Time Spent Learning In All Courses</h4>
                <div>
                    <apx-chart [series]="chartOptions2.series" [chart]="chartOptions2.chart" [dataLabels]="chartOptions2.dataLabels"
                      [plotOptions]="chartOptions2.plotOptions" [yaxis]="chartOptions2.yaxis" [xaxis]="chartOptions2.xaxis"
                      [legend]="chartOptions2.legend" [colors]="chartOptions2.colors" [grid]="chartOptions2.grid"></apx-chart>
                </div> -->
            </div>
        </div>
    </div>

    <div class="d-flex relative">
        <mat-form-field class="mat_form_field" appearance="fill" id="compare-dropdown" *ngIf="lastLevelValue == 'all'">
            <mat-label>Compare Data Fields</mat-label>
            <mat-select [(ngModel)]="comparisonSelection">
                <mat-option *ngFor="let level of orgLevels; let i = index" [value]="level" (click)="compareByLevel(level, i, i < managerAtLevelNumber)" [disabled]="i < managerAtLevelNumber || isLowerThanSelectedLevels(i)">
                    {{ capitalizeFirstWord(level) }}
                </mat-option>
            </mat-select>
        </mat-form-field>

		<div class="exportCsv" *ngIf="lastLevelValue != 'all'">
			<button class="generate_btn export_csv" (click)="toggleShowTeamMembers()" id="show_team_members_btn">
				<span *ngIf="isShowTeamEnabled">Hide Team Members</span>
				<span *ngIf="!isShowTeamEnabled">Show Team Members</span>
			</button>
		</div>
    </div>

    <div>
        <!-- Admin Analytics -->
		<div class="d-flex compareBoxes" [ngClass]="{'extraPaddingOnCards': compareBoxesPrograms.length >= 1}" *ngIf="lastLevelValue == 'all'">
			<div class="big-box" *ngIf="compareBoxesPrograms.length >= 1">
				<h2 class="head">Programs</h2>
				<div *ngIf="compareBoxesPrograms.length >= 1; else noPrograms">
					<div class="program_rows" *ngFor="let program of compareBoxesPrograms">
						<div class="prog_nme">{{ program.name }}</div>
					</div>
				</div>

				<ng-template #noPrograms>
					No programs available
				</ng-template>
			</div>

            <div class="boxs-wrapper" *ngIf="compareBoxes && compareBoxes.length >= 1">
                <div class="box" *ngFor="let box of compareBoxes">
					<div class="d-flex" id="box_display_header">
						<h2 class="head">{{ box.displayName }}</h2>
						<span>{{ box.numUsers }}</span>
					</div>
                    <div class="program_row" *ngFor="let program of box.programs">
                        <div *ngIf="program.numUsers >= 1; else noUsers" class="row_min">
                            <!-- <div class="prog_nme">{{program.name}}</div> -->
							<div class="w3-border" style="display: flex;align-items: center;font-size: 10px;">
								<!-- <div [ngStyle]="{'display': 'flex', 'width': 'calc(100% - ' + program.notStartedPercentage + '%)'}"> -->
								<div *ngIf="program.completedPercentage" class="w3-grey" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': program.completedPercentage +'%'}">
									<span *ngIf="program.completedPercentage >= 11">
										{{program.numCompleted}}
									</span>
									<div class="complete-tooltip tooltip-box">{{program.completedPercentage +'%'}} ({{program.numCompleted}})</div>
								</div>

								<div *ngIf="program.progressPercentage" class="w3-inprogress" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': program.progressPercentage +'%'}">
									<span *ngIf="program.progressPercentage >= 11">
										{{program.numProgress}}
									</span>
									<div class="progress-tooltip tooltip-box">{{program.progressPercentage}}% ({{program.numProgress}})</div>
								</div>
								<!-- </div> -->

								<div *ngIf="program.notStartedPercentage" class="w3-notstarted" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': program.notStartedPercentage +'%'}">
									<span *ngIf="program.notStartedPercentage >= 11">
										{{program.numNotStarted}}
									</span>
									<div class="notStarted-tooltip tooltip-box">{{program.notStartedPercentage}}% ({{program.numNotStarted}})</div>
								</div>
							</div>

                            <span>{{program.eligibleUsersCount}}</span>
                        </div>

						<ng-template #noUsers class="row_min">
							<div class="w3-border" style="display: flex;align-items: center;font-size: 10px;">
								<div class="w3-notstarted" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': '100%'}">
									{{program.eligibleUsersCount}}
									<div class="notStarted-tooltip tooltip-box">100% ({{program.eligibleUsersCount}})</div>
								</div>
							</div>

                            <span>{{program.eligibleUsersCount}}</span>
						</ng-template>
                    </div>
                </div>
            </div>
		</div>

		<div *ngIf="isShowTeamEnabled && lastLevelValue != 'all'">
			<!-- Admin Analytics -->
			<div class="d-flex compareBoxes" [ngClass]="{'extraPaddingOnCards': stmPrograms.length >= 1}">
				<div class="big-box" *ngIf="stmPrograms.length >= 1; else noStmPrograms">
					<h2 class="head">Programs</h2>
					<div>
						<div class="program_rows" *ngFor="let program of stmPrograms">
							<div class="prog_nme">{{ program.name }}</div>
						</div>
					</div>
				</div>

				<ng-template #noStmPrograms>
					No programs available
				</ng-template>

				<div class="boxs-wrapper" *ngIf="showTeamMembers && showTeamMembers.length >= 1; else noShowTeamMembers">
					<div class="stm-user-box" *ngFor="let box of showTeamMembers">
						<div class="d-flex w3-notstarted" id="box_display_header">
							<h2 class="head" *ngIf="box.displayName.length > 32">{{ box.displayName.substring(0, 32) }}...</h2>
							<h2 class="head" *ngIf="box.displayName.length <= 32">{{ box.displayName }}</h2>
							<div class="notStarted-tooltip tooltip-box-name">{{ box.displayName }}</div>
							<!-- <h2 class="head">{{ getDisplayName(box.displayName) }}</h2> -->
						</div>
						<div class="program_row" *ngFor="let program of box.programs">
							<div class="w3-border" style="display: flex;align-items: center;font-size: 10px;">
								<div *ngIf="program.completedPercentage" class="w3-grey" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': program.completedPercentage +'%'}" [id]="'item-completed' + i">
									<span>
										{{program.completedPercentage}}
									</span>
									<div class="complete-tooltip tooltip-box">{{program.completedPercentage +'%'}} ({{program.completedPercentage}})</div>
								</div>

								<div *ngIf="program.remainingPercentage" class="w3-notstarted" [ngStyle]="{'height':'15px', 'text-align': 'center', 'width': program.remainingPercentage +'%'}" [id]="'item-progress' + i">
									<span>
										{{program.remainingPercentage}}
									</span>
									<div class="notStarted-tooltip tooltip-box">{{program.remainingPercentage}}% ({{program.remainingPercentage}})</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<ng-template #noShowTeamMembers>
					No team members available.
				</ng-template>
			</div>
		</div>
    </div>

    <div class="second-row-cards">
        <div class="avg-box">
            <h4 class="card-top-title">Ave Mthly Learning Time</h4>
            <p>{{ avgLearningTime }}</p>
        </div>

        <div class="avg-box">
            <h4 class="card-top-title enrollments-title">No. Enrollments</h4>
            <p>{{ coursesInProgress }}</p>
        </div>

        <div class="avg-box">
            <h4 class="card-top-title">Average Quiz Score</h4>
            <p>{{ avgQuizScore }} %</p>
        </div>

        <div class="avg-box">
            <h4 class="card-top-title">New Learners This Month</h4>
            <p>{{ newLearnersThisMonth }}</p>
        </div>

        <!-- <div class="avg-box comming-soon-box">
            <h4 class="card-top-title">Staff Turnover Rate</h4>
            <div>
                <p>Coming </p>
                <p>Soon <span class="emoji">🥳</span></p>
            </div>
        </div> -->
        <div class="avg-box coming-soon-box">
            <h4 class="card-top-title">Staff Turnover Rate</h4>
            <p>Coming Soon</p>
        </div>
    </div>

    <div class="thired-row-cards">
        <div class="second_container">
            <h2 class="card-top-title">
                Team’s Favourite Categories
            </h2>

            <div class="categ_bars" *ngFor="let category of favoriteCategories">
                <h2 class="card-top-sub-title">{{ category.name }}</h2>
                <div class="progress_bar">
                    <div class="complete progress" style="height: 10px">
                        <div role="progressbar" class="progress-bar" [style.width]="category.share + '%'"
                            aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="monthly_activity">
            <img src="../../../../../assets/images/team-analytics/7.png" alt="">
            <!-- <div class="card-top-title">
                <span>Daily D.O.S.E Activity</span>
                <span>{{ currentMonthName }} {{ currentYear }}</span>
            </div>

            <div class="bars">
                <div *ngFor="let dailyDoseBar of dailyDoseBars" class="graph_bar" [style.height.mm]="dailyDoseBar"></div>
            </div> -->
        </div>
    </div>


    <div class="main_container" style="display: none;">
        <div class="analytics_page_left_side">
            <div class="first_container">
                <!-- <div class="container">
                    <div class="container_head">
                        Av. Streak / Person
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ avgStreakPerPerson }}</div>
                    </div>
                </div>

                <div class="container">
                    <div class="container_head">
                        Ave Mthly Learning Time
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ avgLearningTime }}</div>
                    </div>
                </div> -->

                <!-- <div class="container">
                    <div class="container_head">
                        Av. Log In Time
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ avgLoginTime }}</div>
                        <span class="coming_s">Coming Soon</span>
                        <span class="emoji">🥳</span>
                    </div>
                </div> -->

                <!-- <div class="container">
                    <div class="container_head">
                        No. Enrollments
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ coursesInProgress }}</div>
                    </div>
                </div>

                <div class="container">
                    <div class="container_head">
                        Average Quiz Score
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ avgQuizScore }}</div>
                    </div>

                    <div class="graph_container btnn btnn-default">
                        <div id="chart" class="area_chart">
                            <apx-chart [grid]="chartOptions.grid" [series]="chartOptions.series"
                                [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis" [stroke]="chartOptions.stroke"
                                [tooltip]="chartOptions.tooltip" [dataLabels]="chartOptions.dataLabels"></apx-chart>
                        </div>
                    </div>
                </div> -->

                <!-- <div class="container">
                    <div class="container_head">
                        Av. Points / Person
                    </div>
                    <div class="marks">
                        <div class="marks_obtain">{{ avgPointsPerPerson }}</div>
                    </div>
                </div> -->
            </div>
			<!-- <div class="average_course_container">
                <div class="container">
                    <h2>Your Industry Av.</h2>
                    <p>18 / <span class="desktop">month</span><span class="mobile">m</span> </p>
                    <h3>Completing Daily
                        D.O.S.E's</h3>
                </div>

                <div class="container">
                    <h2>Your Company Av.</h2>
                    <p>{{ companyAverage }} / <span class="desktop">month</span><span class="mobile">m</span></p>
                    <h3>Completing Daily
                        D.O.S.E's</h3>
                </div>

                <div class="container">
                    <h2>Your Monthly Av.</h2>
                    <p>{{ hasProgress ? dosesCompleted : 0 }} / <span class="desktop">month</span><span class="mobile">m</span></p>
                    <h3>Completing Daily
                        D.O.S.E's</h3>
                </div>
            </div> -->

			<!-- <div class="d-flex relative">
				<mat-form-field class="mat_form_field" appearance="fill" id="compare-dropdown">
					<mat-label>Compare Data Fields</mat-label>
					<mat-select [(ngModel)]="comparisonSelection">
						<mat-option *ngFor="let level of orgLevels; let i = index" [value]="level" (click)="compareByLevel(level, i)">
							{{ capitalizeFirstWord(level) }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div> -->

            <!-- <div class="second_container">
                <h2 class="sec_container_head">
                    Team’s Favourite Categories
                </h2>

                <div class="categ_bars" *ngFor="let category of favoriteCategories">
                    <h2 class="bar_head">{{ category.name }}</h2>
                    <div class="progress_bar">
                        <div class="complete progress" style="height: 10px">
                            <div role="progressbar" class="progress-bar" [style.width]="category.share + '%'"
                                aria-valuenow="course.progressCompleted" aria-valuemin="0" aria-valuemax="100">
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <!-- <div class="analytics_page_right_side"> -->
            <!-- <div class="turnover_container"> -->
                <!-- <div class="turnover">
                    <h2>Staff Turnover Rate</h2>
                    <span class="coming_s">Coming Soon</span>
                    <span class="emoji">🥳</span>

                </div> -->

                <!-- <div class="turnover">
                    <h2>Engagement Score</h2>
                    <p>{{ engagementScore }}%</p>
                    <span class="coming_s">Coming Soon</span>
                        <span class="emoji">🥳</span>
                    <p class="company">Your Company</p>
                    <div class="indus_percent">
                        <span class="per">0%</span>

                        <span class="coming_s">Coming Soon</span>
                        <span class="emoji">🥳</span>
                        <span class="industry">Industry</span></div>
                </div> -->

                <!-- <div class="turnover">
                    <h2>Total Locations</h2>
                    <p>{{ numberOfLocations }}</p>
                </div>

                <div class="turnover">
                    <h2>Total Learners</h2>
                    <p>{{ numberOfUsers }}</p>
                </div> -->
            <!-- </div> -->

            <!-- <div class="monthly_activity">
                <div class="header">
                    <span class="activity_head">Daily D.O.S.E Activity</span>
                    <span class="date">{{ currentMonthName }} {{ currentYear }}</span>
                </div>

                <div class="bars">
                    <div *ngFor="let dailyDoseBar of dailyDoseBars" class="graph_bar" [style.height.mm]="dailyDoseBar"></div>
                </div>
            </div> -->
        <!-- </div> -->
    </div>

	<div class="exportCsv">
		<button class="generate_btn export_csv" (click)="toggleShowData()">
			<span *ngIf="isShowDataEnabled">Hide List</span>
			<span *ngIf="!isShowDataEnabled">Show List</span>
		</button>
		<button *ngIf="isShowDataEnabled" (click)="exportToExcel()" class="generate_btn export_csv" id="export_csv_button">Export CSV</button>
	</div>

	<div *ngIf="isShowDataEnabled">
		<div id="users-list" *ngIf="gotUpdatedData; else gettingUpdatedData">
			<div class="table-box" #TABLE *ngIf="numberOfUsers >= 1">
				<table #table mat-table [dataSource]="progressData" matSort (matSortChange)="changeSortTable($event)" class="mat-elevation-z8">
					<ng-container *ngFor="let column of this.orgLevels">
						<ng-container [matColumnDef]="column">
							<th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'country-center-align-th': column === 'country'}"> {{ column }} </th>
							<td mat-cell *matCellDef="let element" [ngClass]="{'country-center-align-td': column === 'country'}"> {{ element[column.toLowerCase()] }} </td>
						</ng-container>
					</ng-container>

					<ng-container matColumnDef="name">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
						<td mat-cell *matCellDef="let element"> {{ element.name }} </td>
					</ng-container>

					<ng-container matColumnDef="programName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Program </th>
						<td mat-cell *matCellDef="let element"> {{ element.programName ? element.programName : "-" }} </td>
					</ng-container>

					<ng-container matColumnDef="started">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Started </th>
						<td mat-cell *matCellDef="let element"> {{ element.startedAt ? (element.startedAt | date: "medium") : "-" }} </td>
					</ng-container>

					<ng-container matColumnDef="completed">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Completed </th>
						<td mat-cell *matCellDef="let element"> {{ element.completedAt ? (element.completedAt | date: "medium") : "-" }} </td>
					</ng-container>

					<ng-container matColumnDef="progress">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Progress </th>
						<td mat-cell *matCellDef="let element"> {{ element.progress ? element.progress: "-" }} </td>
					</ng-container>

					<ng-container matColumnDef="avgQuizScore">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Score </th>
						<td mat-cell *matCellDef="let element"> {{ element.avgQuizScore ? element.avgQuizScore : "-" }} </td>
					</ng-container>

					<ng-container matColumnDef="earnedPts">
						<th mat-header-cell *matHeaderCellDef mat-sort-header> Points </th>
						<td mat-cell *matCellDef="let element"> {{ element.earnedPts ? element.earnedPts : "-" }} </td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="progressTableColumnNames"></tr>
					<tr mat-row *matRowDef="let row; columns: progressTableColumnNames;"></tr>
				</table>
				<mat-paginator [pageSizeOptions]="[100]" showFirstLastButtons></mat-paginator>
			</div>
		</div>

		<ng-template #gettingUpdatedData>
			<h3 id="getting_data">
				<img src="../../../../../assets/gifs/wait3.gif" alt="Loading gif" id="loading_gif">
			</h3>
		</ng-template>
	</div>
</div>
